import { onboardingApi } from './onboardingApi';

const vendorsApi = onboardingApi.injectEndpoints({
  endpoints: (build) => ({
    getVendors: build.query({
      query: () => {
        return {
          url: '/vendors/vendor-bridge',
          method: 'get'
        };
      },
      providesTags: ['vendors']
    }),
    sendBatchEmail: build.mutation({
      query: (data) => {
        return {
          url: '/vendors/batch-email',
          method: 'post',
          data: {
            vendors: data.vendors,
            emailText: data.emailText
          }
        };
      },
      invalidatesTags: ['vendors']
    })
  }),
  overrideExisting: false
});

export const { useGetVendorsQuery, useSendBatchEmailMutation } = vendorsApi;
